import styled from 'styled-components'

const StyledSocialSelectSlide = styled.div`
  
`

export default StyledSocialSelectSlide
